export default "__VITE_ASSET__B89HZQox__"